<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
       width="100%" viewBox="0 0 182 182" enable-background="new 0 0 182 182" xml:space="preserve">
    <path :fill="fillColor" opacity="1.000000" stroke="none"
          d="
M97.804825,160.999100
	C84.233322,161.864166 71.619934,160.014847 59.875927,153.917938
	C56.104370,151.959915 52.631847,149.425903 48.018620,146.523895
	C44.716156,150.134628 41.353382,154.015579 37.767559,157.678162
	C33.637856,161.896286 27.817646,162.394974 24.568171,159.046906
	C20.739408,155.101974 21.159737,150.315109 25.908571,145.632614
	C29.578405,142.014023 33.385880,138.535034 37.065804,135.056717
	C17.477089,109.755943 16.510025,72.668053 37.761196,47.645679
	C52.355011,30.462069 70.733391,21.985239 93.169357,21.998785
	C110.160522,22.009045 127.156685,22.247311 144.140900,21.903427
	C153.507217,21.713787 161.514694,29.715155 161.167526,38.991344
	C160.563629,55.127010 160.573227,71.315781 161.110123,87.456200
	C161.749191,106.667534 156.528107,123.402496 143.708069,137.993286
	C131.528305,151.855392 116.354858,159.119125 97.804825,160.999100
M80.306808,116.003426
	C84.677208,116.507011 86.328445,114.521675 86.055557,110.212708
	C85.806725,106.283600 86.002838,102.326317 86.002838,98.271484
	C90.211922,98.271484 93.934708,98.271484 97.996483,98.271484
	C97.996483,101.330139 97.996445,104.125328 97.996490,106.920517
	C97.996620,116.151489 97.996635,116.151337 107.363136,116.003983
	C107.695702,115.998756 108.029411,115.985115 108.360886,116.004486
	C111.787560,116.204819 113.106911,114.543076 113.040459,111.183243
	C112.916229,104.902794 113.004730,98.618149 113.004730,92.324883
	C115.331398,92.052971 117.212479,91.833130 119.758675,91.535561
	C118.897621,90.104004 118.528679,89.010582 117.783829,88.326401
	C110.192429,81.353256 102.528618,74.459045 94.911560,67.513687
	C92.761848,65.553551 90.895920,65.834000 88.825241,67.740402
	C81.608475,74.384621 74.286247,80.914268 67.066948,87.555779
	C66.008911,88.529129 65.291603,89.872856 63.975811,91.635872
	C66.944984,91.911430 68.843109,92.087585 70.991631,92.286980
	C70.991631,97.546356 70.991379,102.513832 70.991692,107.481308
	C70.992233,116.000885 70.992378,116.000885 80.306808,116.003426
z"/>
    <path :fill="fontColor" opacity="1.000000" stroke="none"
          d="
M79.852509,116.003464
	C70.992378,116.000885 70.992233,116.000885 70.991692,107.481308
	C70.991379,102.513832 70.991631,97.546356 70.991631,92.286980
	C68.843109,92.087585 66.944984,91.911430 63.975811,91.635872
	C65.291603,89.872856 66.008911,88.529129 67.066948,87.555779
	C74.286247,80.914268 81.608475,74.384621 88.825241,67.740402
	C90.895920,65.834000 92.761848,65.553551 94.911560,67.513687
	C102.528618,74.459045 110.192429,81.353256 117.783829,88.326401
	C118.528679,89.010582 118.897621,90.104004 119.758675,91.535561
	C117.212479,91.833130 115.331398,92.052971 113.004730,92.324883
	C113.004730,98.618149 112.916229,104.902794 113.040459,111.183243
	C113.106911,114.543076 111.787560,116.204819 108.360886,116.004486
	C108.029411,115.985115 107.695702,115.998756 107.363136,116.003983
	C97.996635,116.151337 97.996620,116.151489 97.996490,106.920517
	C97.996445,104.125328 97.996483,101.330139 97.996483,98.271484
	C93.934708,98.271484 90.211922,98.271484 86.002838,98.271484
	C86.002838,102.326317 85.806725,106.283600 86.055557,110.212708
	C86.328445,114.521675 84.677208,116.507011 79.852509,116.003464
z"/>
</svg>
</template>

<script>
export default {
  name: 'MainLogo',
  props: {
    fillColor: {
      type: String,
    },
    fontColor: {
      type: String,
    }
  }
}
</script>
